import "react-country-state-city/dist/react-country-state-city.css";
import {GetCountries, GetState} from "react-country-state-city";
import {Country} from "react-country-state-city/dist/cjs/types";

/**
 * This is a utility interface to represent a country
 */
export interface CountrySelection {
  id: number;
  isoCode2: string;
  name: string;
  hasStates: boolean;
}

export interface StateSelection {
  id: number;
  name: string;
  code: string;
}

/**
 * We store this list so we don't have to recompute it all the time
 */
const countryList: CountrySelection[] = [];
const loadedListOfCountries: Country[] = [];
const statesList: Map<string, StateSelection[]> = new Map<string, StateSelection[]>();

/**
 * This function is used to lazily load the country list
 */
export async function loadCountryData(): Promise<CountrySelection[]> {
  // Return list if already computed
  if (countryList.length > 0) {
    return countryList;
  }

  await GetCountries(`${window.location.origin}/ams/ui`).then((countries) => {
    countries.forEach(country => {
      loadedListOfCountries.push(country);
      countryList.push({
        id: country.id,
        isoCode2: country.iso2,
        name: country.name,
        hasStates: country.hasStates
      })
    });
  });

  return countryList;
}

export async function loadStateData(iso2Code: string): Promise<StateSelection[]> {
  if (statesList.has(iso2Code) && statesList.get(iso2Code)) {
    return statesList.get(iso2Code) as StateSelection[];
  }

  const countryId = loadedListOfCountries.find(c => c.iso2 === iso2Code)?.id;
  if (countryId) {
    await GetState(countryId, `${window.location.origin}/ams/ui`).then((states) => {
      const listOfStates: StateSelection[] = [];
      states.forEach(state => {
        listOfStates.push({
          id: state.id,
          name: state.name,
          code: state.state_code
        });
      });
      statesList.set(iso2Code, listOfStates);
    });

    return statesList.get(iso2Code) as StateSelection[];
  }
  return [];
}